(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dashboard-social-media"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.getElementById('dashboard-social-list');
    if (!el) return;

    var configEl = el.querySelector('[data-config-json]');
    var cfg = {};
    try {
      cfg = JSON.parse((configEl && configEl.textContent) || '{}');
    } catch (e) {
      cfg = {};
    }
    cfg.platforms = cfg.platforms || {};
    cfg.errors = cfg.errors || {};
    cfg.returnMessages = cfg.returnMessages || {};

    var statusUrl = el.getAttribute('data-social-status-url') || '/apps/lensza/social-status';
    var connectUrl = el.getAttribute('data-social-connect-url') || '/apps/lensza/social-connect';

    function platformLabel(id) {
      return cfg.platforms[id] || id;
    }

    function setStatus(row, text) {
      var s = row.querySelector('[data-status]');
      if (s) s.textContent = text;
    }

    function setConnectLabel(row, points) {
      var btn = row.querySelector('[data-connect-oauth]');
      if (!btn) return;
      var text = btn.querySelector('.btn-text');
      var label = (points > 0 && cfg.connectWithPoints)
        ? cfg.connectWithPoints.replace('%points%', points)
        : (cfg.connect || 'Connect');
      if (text) text.textContent = label;
      btn.hidden = false;
    }

    function markConnected(row, handle) {
      row.setAttribute('data-connected', 'true');
      var btn = row.querySelector('[data-connect-oauth]');
      var badge = row.querySelector('[data-connected-badge]');
      if (btn) btn.hidden = true;
      if (badge) badge.hidden = false;
      setStatus(row, handle || cfg.connected || 'Connected');
    }

    function errorMessage(status, data) {
      if (status === 401) return cfg.errors.loginRequired;
      if (status === 404) return cfg.errors.accountNotFound;
      if (status === 400) return cfg.errors.unsupportedPlatform;
      if (data && (data.detail || data.error)) return data.detail || data.error;
      return cfg.errors.generic;
    }

    function reasonText(reason) {
      return cfg.returnMessages[reason] || cfg.returnMessages.genericError;
    }

    function handleReturnFlag() {
      var params = new URLSearchParams(window.location.search);
      var social = params.get('social');
      if (!social) return;

      var match = /^([a-z]+)_(ok|err)$/.exec(social);
      if (match) {
        var platform = match[1];
        var result = match[2];
        var row = el.querySelector('[data-platform="' + platform + '"]');
        if (row) {
          if (result === 'ok') {
            var msg = cfg.returnMessages.success || '';
            setStatus(row, msg.replace('%platform%', platformLabel(platform)));
          } else {
            var reason = params.get('reason');
            var msg2 = reasonText(reason) || '';
            setStatus(row, msg2.replace('%platform%', platformLabel(platform)));
          }
        }
      }

      params.delete('social');
      params.delete('reason');
      var qs = params.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
    }

    // Drops the row skeletons once the status request settles, success or failure, so a
    // failed fetch rests on the real rows instead of shimmering forever.
    function stopLoading() {
      el.removeAttribute('data-loading');
      el.removeAttribute('aria-busy');
    }

    function loadStatus() {
      fetch(statusUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('social-status failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var links = (data && data.links) ? data.links : [];
          var points = (data && data.points) ? data.points : {};
          var rows = el.querySelectorAll('[data-platform]');
          rows.forEach(function (row) {
            if (row.getAttribute('data-connected') === 'true') return;
            var pid = row.getAttribute('data-platform');
            var link = links.find(function (l) {
              return (l.platform || '').toLowerCase() === pid;
            });
            if (link) {
              markConnected(row, link.handle);
            } else {
              setStatus(row, cfg.notConnected || 'Not connected');
              setConnectLabel(row, points[pid] || 0);
            }
          });
        })
        .catch(function () {
          el.querySelectorAll('[data-platform]').forEach(function (row) {
            setStatus(row, '—');
            if (row.getAttribute('data-connected') !== 'true') {
              setConnectLabel(row, 0);
            }
          });
        })
        .then(stopLoading, stopLoading);
    }

    el.querySelectorAll('[data-connect-oauth]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-platform]');
        if (!row) return;
        var platform = row.getAttribute('data-platform');

        btn.disabled = true;
        btn.classList.add('loading');
        setStatus(row, cfg.connecting || 'Redirecting...');

        fetch(connectUrl + '?platform=' + encodeURIComponent(platform), { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r
              .json()
              .catch(function () { return {}; })
              .then(function (data) { return { res: r, data: data }; });
          })
          .then(function (result) {
            if (result.res.ok && result.data.authorize_url) {
              window.location.href = result.data.authorize_url;
              return;
            }
            setStatus(row, errorMessage(result.res.status, result.data));
            btn.disabled = false;
            btn.classList.remove('loading');
          })
          .catch(function () {
            setStatus(row, cfg.errors.network);
            btn.disabled = false;
            btn.classList.remove('loading');
          });
      });
    });

    handleReturnFlag();
    loadStatus();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-star-rating"] && !Shopify.designMode) return;
  try {
    (() => {
    const LINK_SELECTOR = '.review-star-rating-link';

    const findReviews = () => document.querySelector('product-reviews');

    // The Product Reviews section is optional, so mark the badge inert when the
    // merchant hasn't added it — otherwise the link would be a dead fragment.
    const syncState = () => {
      const hasTarget = Boolean(findReviews());
      document
        .querySelectorAll(LINK_SELECTOR)
        .forEach((link) => link.toggleAttribute('data-no-target', !hasTarget));
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.(LINK_SELECTOR);
      if (!link) return;

      const reviews = findReviews();
      if (!reviews) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      reviews.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncState);
    } else {
      syncState();
    }

    // Sections come and go in the theme editor.
    document.addEventListener('shopify:section:load', syncState);
    document.addEventListener('shopify:section:unload', syncState);
  })();
  } catch(e) { console.error(e); }
})();

})();
